import Vue from 'vue'
import axios from 'axios'
import router from '../router/index'
import { Message } from 'iview'
import util from './util'
import store from '@/store';
// import { Message, Loading } from 'element-ui';
Vue.prototype.$axios = axios
// axios.defaults.baseURL = 'http://192.168.0.112:8111/wandaiticketAdminApi_war'
// axios.defaults.baseURL = 'http://yyb4px.natappfree.cc/'
store.state.baseUrl = 'https://java.wandaicloud.com';
// store.state.baseUrl = 'https://java.techolic.cn';
// store.state.baseUrl = 'http://127.0.0.1:28326/admin';

axios.defaults.baseURL = store.state.baseUrl
// axios.defaults.baseURL = 'http://127.0.0.1:28326/admin'
// axios.defaults.baseURL = 'http://wandaipiaowuadminserver.touchdot.top/'

// 设置baseURL
// if (location.hostname === 'localhost') axios.defaults.baseURL = store.state.devUrl;
// else axios.defaults.baseURL = store.state.formalUrl;
console.log(store);
let loadingCount = 0,
  loading,
  go = {}
  go.baseURL = axios.defaults.baseURL;
export const showLoading = () => {
  // if (loadingCount === 0) loading = Loading.service({
  //   text: 'Loading...'
  // });
  // loadingCount++;
}
export const hideLoading = () => {
  // if (loadingCount <= 0) return;
  // loadingCount--;
  // if (loadingCount === 0) loading.close();
}
// 请求拦截
axios.interceptors.request.use(
  config => {
    
    let token = window.localStorage.getItem('token')
    if (token && !config.url.includes('uploadSingleFile')) {
      // config.headers['wandaiticket-admin-token'] = token
    }
    if (!config.data) {
      config.data = {}
    }
    return config
  },
  err => {
    console.log('请求失败', err)
    Message.error('请求数据失败')
    return Promise.reject(err)
  }
)
// 响应拦截
axios.interceptors.response.use(
  res => {
    console.log('响应成功:' + res.config.url, res)
    hideLoading()
    if(res.status === 203){
      Message.error('请重新登录')
      router.push({ name: 'Login' })
      return Promise.resolve(res)
    }

    if (res.data.meta.success) {
      return Promise.resolve(res)
    } else if (res.status === 203) {
      Message.error('请重新登录')
      router.push({ name: 'Login' })
    } else {
      Message.error(
        res.data.meta.message ? res.data.meta.message : 'Unknown mistake'
      )
      return Promise.resolve(res)
    }
  },
  err => {
    console.log('响应失败', err)
    return Promise.resolve(err.response)
  }
)
axios.defaults.withCredentials =true;

// post请求
go.post = function(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// get请求
go.get = function(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// delete请求
go.delete = function(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, { params })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

go.put = function(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then(res => {
        console.log(res)
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

go.uploadFile = async (filePath, formData) => {
  let data = formData;
  data.append('file', filePath)
  let config = {
    headers: { 'Content-Type': 'multipart/form-data' },
    //跨域请求时是否需要使用凭证
    withCredentials: true,
    // 返回数据类型
    responseType: 'json' //default
  }
  let result = await axios.post(
    axios.defaults.baseURL+'uploadExcelFile',
    data,
    config
  )
  console.log(result)
  return result
}

// 导出
export default go



// WEBPACK FOOTER //
// ./src/libs/http.js